import { createAction } from '@reduxjs/toolkit'
import { IEntity, PutEntityAttributeResponse } from 'types/GlobalEntities'
import { PutSimRenamingResponse } from 'redux/api/SimRenamings'

// tryGetAllEntities
export const getAll = createAction('get_all_entities')
export const getAllSuccess = createAction<IEntity[]>('get_all_entities_success')
export const getAllFailed = createAction('get_all_entities_failed')

// tryPutEntityAttributes
export const putAttributes = createAction('put_entity_attributes')
export const putAttributesSuccess = createAction<{
  data: PutEntityAttributeResponse[]
  entityId: string
}>('put_entity_attributes_success')
export const putAttributesFailed = createAction('put_entity_attributes_failed')

// tryPutTerminology
export const putTerminology = createAction('put_terminology')
export const putTerminologySuccess = createAction<{
  data: PutSimRenamingResponse[]
  entityId: string
}>('put_terminology_success')
export const putTerminologyFailed = createAction('put_terminology_failed')
